<template>
<div>
  <div class="row">
    <!-- Title -->
    <div class="stage-title">Kontrola przekazywania danych</div>
    <hr/>
  </div>
  <div class="row top-space">
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a :class="fileControlTabClass" aria-current="page" @click="openReportControlStage('fileControlTab')">Kontrola plików</a>
      </li>

    </ul>

    <div v-if="currentControlTab === 'fileControlTab'">
      <ReportsControlFilesListStage/>
    </div>
    <!--      <div v-else-if="currentPaymentType === 'PAID'">-->
    <!--        <PaidPaymentsStage/>-->
    <!--      </div>-->
    <!--      <div v-else-if="currentPaymentType === 'PROBLEMATIC'">-->
    <!--              <ProblematicPaymentsStage/>-->
    <!--      </div>-->




  </div>



  </div>
</template>

<script>

import ReportsControlFilesListStage from "./ReportsControlFilesListStage.vue";
import {useReportsManagerModule} from "@/state/pinia/reportsManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";

export default {
  name: "ReportsControlStage",
  props: {},
  components: {
    ReportsControlFilesListStage
    // FontAwesomeIcon,
    // CommonChart,
  },
  data() {
    return {
      fileControlTabClass: "nav-link active",
      currentControlTab:"fileControlTab",
    };
  },
  computed: {
    reportsModule(){
      return useReportsManagerModule();
    },

    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
  },
  methods: {


    openReportControlStage(openedPaymentType){
      this.currentControlTab = openedPaymentType;
      if(this.currentControlTab === 'fileControlTab'){
        this.fileControlTabClass = "nav-link active";
      }else{
        this.fileControlTabClass = "nav-link";
      }

    }
  },
  created() {
    this.simplepharmAuth.refreshToken().then(() => {
      this.commonModule.httpGetLicensedFeatures();
      this.commonModule.httpGetWorkingProfile();
    });
  },
};
</script>

<style scoped>



</style>
